// extracted by mini-css-extract-plugin
module.exports = {"switch-wrapper":"stage_settings__switch-wrapper___2dwX3","switchWrapper":"stage_settings__switch-wrapper___2dwX3"};